// ── Manager CRUD ──────────────────────────────────────────────────────────────
import { API_BASE } from './base'
import type { Manager, ManagerDetail } from '@/types'

//基金经理列表（原）
export async function getManagers(): Promise< ManagerDetail[]> {
    const res = await fetch(`${API_BASE}/managers`)
    return res.json()
}

//基金经理列表
export async function getManagersByStyle(): Promise<{style: string,count:number, managers: ManagerDetail[]}[]> {
    const res = await fetch(`${API_BASE}/managers/styles`)
    return res.json()
}

//基金经理详情
export async function getManagersDetail(id:number): Promise<ManagerDetail> {
    const res = await fetch(`${API_BASE}/managers/${id}`)
    return res.json()
}


//创建基金经理
export async function createManager(data: Manager): Promise<void> {
    const res = await fetch(`${API_BASE}/managers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data }),
    })
    if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        throw new Error((err as { detail?: string }).detail ?? '创建失败')
    }
}

//更新基金经理
export async function updateManager(manager: Partial<ManagerDetail>): Promise<void> {
    const res = await fetch(`${API_BASE}/managers/${manager.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...manager }),
    })
    if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        throw new Error((err as { detail?: string }).detail ?? '保存失败')
    }
}

//删除基金经理
export async function deleteManager(name: string): Promise<void> {
    await fetch(`${API_BASE}/managers/${encodeURIComponent(name)}`, { method: 'DELETE' })
}

//基金经理默认股票池
export async function getManagerDefaultPool(id: number) {
    const res = await fetch(`${API_BASE}/managers/${id}/default_pool`)
    return res.json()
}

//基金经理默认股票池
export async function setManagerDefaultPool(id: number, poolId: number | null): Promise<void> {
    const res = await fetch(`${API_BASE}/managers/${id}/default-stock-pool`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ stock_pool_id: poolId }),
    })
    return res.json()
}